import {
  ADD_TO_RECEIVE,
  REMOVE_FROM_RECEIVE,
  REMOVE_ALL_FROM_RECEIVE
} from "@/store/mutation-types";

const state = {
  receiveStore: []
};

const getters = {
  receiveStore: state => state.receiveStore
};

const mutations = {
  ADD_TO_RECEIVE: (state, sample) => {
    state.receiveStore =  [...state.receiveStore, sample]
  },
  REMOVE_FROM_RECEIVE: (state, id) => {
    state.receiveStore = state.receiveStore.filter(item => item.id !== id);
  },
  REMOVE_ALL_FROM_RECEIVE: (state) => {
    state.receiveStore = []
  }
};

const actions = {
  RECEIVE_ADD: ({commit}, data) => {
    commit(ADD_TO_RECEIVE, data)
  },
  RECEIVE_REMOVE: ({commit}, data) => {
    commit(REMOVE_FROM_RECEIVE, data)
  },
  RECEIVE_REMOVE_ALL: ({commit}) => {
    commit(REMOVE_ALL_FROM_RECEIVE)
  }
};

export default {
  getters,
  mutations,
  actions,
  state
}